import { StructureObjectField } from '../../enums/structure-object';

import titleIcon from '../../../images/icons/structure-object/text-icon.svg';
import amountIcon from '../../../images/icons/structure-object/amount-icon.svg';
import clockIcon from '../../../images/icons/structure-object/oclock-icon.svg';
import descIcon from '../../../images/icons/structure-object/description-icon.svg';
import financeIcon from '../../../images/icons/structure-object/finance-icon.svg';
import userIcon from '../../../images/icons/structure-object/user-icon.svg';
import stageIcon from '../../../images/icons/structure-object/stage-icon.svg';
import projectIcon from '../../../images/icons/dark/projects-icon.svg';

export const structureFinance: StructureObjectField[] = [
    {
        key: 'name',
        label: 'Назва',
        order: 1,
        icon: titleIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'amount',
        label: 'Сума',
        order: 4,
        icon: amountIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'date',
        label: 'Створено',
        order: 5,
        icon: clockIcon,
        visible: true,
    },
    {
        key: 'comment',
        label: 'Опис',
        order: 7,
        icon: descIcon,
        visible: true,
    },
    {
        key: 'responsibleEmail',
        label: 'Відповідальний',
        order: 8,
        icon: userIcon,
        visible: true,
    },
    {
        key: 'typeName',
        label: 'Тип',
        order: 10,
        icon: stageIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'valutaCode',
        label: 'Валюта',
        order: 11,
        icon: amountIcon,
        visible: true,
    },
];

export const structureFinanceOther: StructureObjectField[] = [
    {
        key: 'project',
        label: 'Проєкт',
        order: 1,
        icon: projectIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'selling',
        label: 'Продажі',
        order: 2,
        icon: financeIcon,
        isRequired: true,
        visible: true,
    }
]